interface Raw {
  data: {
    url: string | null;
  };
}

export function transformDownloadUrl(raw: unknown): { url: string | null } {
  return (raw as Raw).data;
}

